import type { HTMLAttributes, ReactNode, Ref } from 'react';

export type TagTone = 'neutral' | 'accent' | 'info' | 'success' | 'warning' | 'danger';
export type TagSize = 'sm' | 'md';

export interface TagProps extends Omit<HTMLAttributes<HTMLSpanElement>, 'className'> {
  tone?: TagTone;
  size?: TagSize;
  className?: string;
  ref?: Ref<HTMLSpanElement>;
  children: ReactNode;
}

/** Plain, non-interactive label marker. Use Chip when the label needs
 *  to be dismissible/interactive; Tag is strictly decorative. */
export function Tag(props: TagProps): ReactNode {
  const { tone = 'neutral', size = 'md', className, ref, children, ...rest } = props;
  const classes = ['vq-tag', className].filter(Boolean).join(' ');
  return (
    <span
      {...rest}
      ref={ref}
      className={classes}
      data-component="Tag"
      data-tone={tone}
      data-size={size}
    >
      {children}
    </span>
  );
}
